import { computed, Ref } from "vue";
import { Panel } from "@/stores/editor_store";

interface PanelHeightProps {
  containerRef?: Ref<HTMLElement>;
}

export function usePanelHeight(props: PanelHeightProps = {}) {
  const { containerRef } = props;

  const editorHeight = computed(() => {
    const editorHeight = containerRef.value?.offsetHeight;
    const minHeight = 368; // almost eq. to 23rem
    const maxHeight = getDrawerMaxHeight();
    if (editorHeight && editorHeight > minHeight && editorHeight < maxHeight) {
      return editorHeight;
    } else if (editorHeight && editorHeight > maxHeight) {
      return maxHeight;
    }

    return minHeight;
  });

  const getPanelHeight = (panel: Panel): string => {
    if (panel === "eraseRestore") {
      return "176px"; // 11rem = 176px
    } else if (panel === "addBackground") {
      return "320px"; // 20rem = 320px
    } else if (panel === "fx") {
      return "240px"; // 15rem = 240px
    } else {
      return "240px"; // default fallback
    }
  };

  const getDrawerHeightInPx = (type: "fullHeight" | "huggingContent"): string => {
    return `${getDrawerHeight(type)}px`;
  };

  const getDrawerHeight = (type: "fullHeight" | "huggingContent"): number => {
    if (type === "fullHeight") {
      return editorHeight.value;
    }

    // TODO: figure out the else condition. This value is dummy.
    return 368;
  };

  const getDrawerMaxHeight = () => {
    const maxEditorHeight = 1080;
    const toolbarHeight = 58;
    const imageNavigationHeight = 88;
    const gap = 16 * 2;
    const panelHeight = maxEditorHeight - toolbarHeight - imageNavigationHeight - gap;
    return panelHeight;
  };

  return {
    getPanelHeight,
    getDrawerHeightInPx,
    getDrawerHeight,
    editorHeight,
  };
}
